import styled from "styled-components";
import {SideSectionComponent} from "./side-section.component";

export const LeftSectionComponent = styled(SideSectionComponent)`
    align-items: flex-start;
`